module.exports = __webpack_public_path__ + "static/media/MaintenanceIMG.12e7aa52.png";